import React from "react";
import logo from "../assets/3d-logo.png";
import {
  Mail,
  Phone,
  MapPin,
  ArrowRight,
  GraduationCap,
  BookOpen,
  Users,
  ShieldCheck,
  Smartphone,
} from "lucide-react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { BsYoutube } from "react-icons/bs";
import { LiaLinkedin } from "react-icons/lia";

const Footer: React.FC = () => {
  const brandLinks = {

    managedBy: "https://nadezhdaventure.in/",
  };

  const contact = {
    phone: "+919412220200",
    displayPhone: "+91 94122 20200",
    email: "support@mediitacademy.com",
  };

  const courses = [
    {
      label: "Class 7 Foundation Course",
      href: "/all-classes?class=class-7",
      title: "Class 7 Foundation Course with Live Classes and Study Material",
    },
    {
      label: "Class 8 Foundation Course",
      href: "/all-classes?class=class-8",
      title: "Class 8 Foundation Course for Science and Mathematics",
    },
    {
      label: "Class 9 Foundation Course",
      href: "/all-classes?class=class-9",
      title: "Class 9 Foundation Course for School Exam Preparation",
    },
    {
      label: "Class 10 Foundation Course",
      href: "/all-classes?class=class-10",
      title: "Class 10 Foundation Course for Board Exam Preparation",
    },
    {
      label: "JEE Foundation Course",
      href: "/all-classes?class=class-11&subject=Maths",
      title: "JEE Foundation Course for Engineering Entrance Preparation",
    },
    {
      label: "NEET Foundation Course",
      href: "/all-classes?class=class-11&subject=Biology",
      title: "NEET Foundation Course for Medical Entrance Preparation",
    },
    {
      label: "Live Online Batches",
      href: "/live-batches",
      title: "Live Online Classes and Batches for Students",
    },
    {
      label: "Online Test Series",
      href: "/real-test",
      title: "Online Test Series for JEE NEET and School Exams",
    },
  ];

  const quickLinks = [
    {
      label: "Home",
      href: "/",
      title: "Mediit Academy Online Learning Platform",
    },
    {
      label: "All Courses",
      href: "/all-classes",
      title: "Explore All Online Courses for Class 7 to 12 JEE and NEET",
    },
    {
      label: "How Live Class Works",
      href: "/how-live-class-works",
      title: "How Mediit Academy Live Classes Work",
    },
    {
      label: "Mediit Skills",
      href: "/mediit-skills",
      title: "Mediit Skills Learning Programs",
    },
    {
      label: "Real Test",
      href: "/real-test",
      title: "Real Test Practice for Students",
    },
    {
      label: "Our Mentors",
      href: "/our-mentors",
      title: "Meet Expert Mentors and Teachers at Mediit Academy",
    },
    {
      label: "Community",
      href: "/community",
      title: "Join Mediit Academy Student Community",
    },
    {
      label: "Student Login",
      href: "/login",
      title: "Student Login for Mediit Academy LMS",
    },
  ];

  const supportLinks = [
    {
      label: "Help Center",
      href: "/help-center",
      title: "Mediit Academy Help Center",
    },
    {
      label: "Ask Doubt",
      href: "/ask-doubt",
      title: "Ask Doubts Online from Expert Teachers",
    },
    {
      label: "Contact Support",
      href: "/contact",
      title: "Contact Mediit Academy Support Team",
    },
    {
      label: "Refund Policy",
      href: "/refund-policy",
      title: "Mediit Academy Refund Policy",
    },
    {
      label: "Privacy Policy",
      href: "/privacy-policy",
      title: "Mediit Academy Privacy Policy",
    },
    {
      label: "Terms & Conditions",
      href: "/terms-and-conditions",
      title: "Mediit Academy Terms and Conditions",
    },
    {
      label: "FAQs",
      href: "/faqs",
      title: "Frequently Asked Questions About Mediit Academy",
    },
    {
      label: "Career",
      href: "/career",
      title: "Career Opportunities at Mediit Academy",
    },
  ];

  const popularCategories = [
    {
      label: "NEET Preparation",
      href: "/all-classes?class=class-11&subject=Biology",
      title: "Best NEET Preparation Online Course",
    },
    {
      label: "JEE Preparation",
      href: "/all-classes?class=class-11&subject=Maths",
      title: "Best JEE Preparation Online Course",
    },
    {
      label: "Class 7 Online Classes",
      href: "/all-classes?class=class-7",
      title: "Class 7 Online Classes with Expert Teachers",
    },
    {
      label: "Class 8 Online Classes",
      href: "/all-classes?class=class-8",
      title: "Class 8 Online Classes with Study Material",
    },
    {
      label: "Class 9 Science & Maths",
      href: "/all-classes?class=class-9",
      title: "Class 9 Science and Mathematics Online Course",
    },
    {
      label: "Class 10 Board Preparation",
      href: "/all-classes?class=class-10",
      title: "Class 10 Board Exam Preparation Online",
    },
    {
      label: "Class 11 Science",
      href: "/all-classes?class=class-11",
      title: "Class 11 Science Online Coaching",
    },
    {
      label: "Class 12 Science",
      href: "/all-classes?class=class-12",
      title: "Class 12 Science Online Coaching",
    },
    {
      label: "Live Classes",
      href: "/live-batches",
      title: "Live Online Classes for School JEE and NEET",
    },
    {
      label: "Doubt Solving",
      href: "/ask-doubt",
      title: "Online Doubt Solving for Students",
    },
    {
      label: "Online Test Series",
      href: "/real-test",
      title: "Online Test Series for Exam Practice",
    },
    {
      label: "Study Material",
      href: "/all-classes",
      title: "Study Notes and Learning Material",
    },
  ];

  const socialLinks = [
    {
      label: "Facebook",
      href: "https://www.facebook.com/mediitacademy/",
      icon: <FaFacebook size={19} />,
      title: "Follow Mediit Academy on Facebook",
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/mediitacademy/",
      icon: <FaInstagram size={19} />,
      title: "Follow Mediit Academy on Instagram",
    },
    {
      label: "YouTube",
      href: "https://www.youtube.com/@MediitAcademy",
      icon: <BsYoutube size={20} />,
      title: "Subscribe Mediit Academy on YouTube",
    },
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/school/mediitacademy/",
      icon: <LiaLinkedin size={19} />,
      title: "Connect with Mediit Academy on LinkedIn",
    },
  ];

  return (
    <footer className="relative overflow-hidden bg-[#07111b] text-white font-['Inter']">
      <div className="absolute -left-24 top-20 h-72 w-72 rounded-full bg-cyan-500/10 blur-3xl" />
      <div className="absolute -right-24 bottom-24 h-80 w-80 rounded-full bg-blue-600/10 blur-3xl" />

      <section className="relative border-b border-white/10 px-4 py-12 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-8 rounded-[2rem] border border-white/10 bg-white/[0.04] p-6 shadow-2xl backdrop-blur sm:p-8 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-8">
            <p className="text-sm font-black uppercase tracking-[0.2em] text-cyan-300">
              Start Learning Today
            </p>

            <h2 className="mt-3 text-3xl font-black leading-tight text-white sm:text-4xl lg:text-5xl">
             Learn Smarter, Prepare Better, and Achieve More with Mediit Academy
            </h2>

            <p className="mt-4 max-w-3xl text-sm leading-7 text-slate-300 sm:text-base">
              Mediit Academy is a smart online learning platform designed for Class 7 to
              Class 12 students, JEE aspirants, and NEET aspirants. We provide live classes,
              structured courses, online test series, study material, doubt-solving support,
              and an active learning community to help students prepare with confidence..
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row lg:col-span-4 lg:justify-end">
            <a
              href="/all-classes"
              title="Explore Mediit Academy Online Courses"
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-cyan-400 px-6 py-4 text-sm font-black text-slate-950 shadow-lg shadow-cyan-500/20 transition hover:-translate-y-0.5 hover:bg-cyan-300"
            >
              Explore Courses
              <ArrowRight size={18} />
            </a>

            <a
              href="/talk-to-counselor"
              title="Talk to Mediit Academy Counselor"
              className="inline-flex items-center justify-center rounded-2xl border border-white/15 bg-white/10 px-6 py-4 text-sm font-black text-white transition hover:bg-white/15"
            >
              Talk to Counselor
            </a>
          </div>
        </div>
      </section>

      <section className="relative px-4 py-14 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="mb-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <div className="rounded-3xl border border-white/10 bg-white/[0.04] p-5">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-cyan-400/15 text-cyan-300">
                <GraduationCap size={24} />
              </div>
              <p className="text-3xl font-black">25k+</p>
              <p className="mt-1 text-sm font-medium text-slate-400">
                Active Students
              </p>
            </div>

            <div className="rounded-3xl border border-white/10 bg-white/[0.04] p-5">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-400/15 text-blue-300">
                <BookOpen size={24} />
              </div>
              <p className="text-3xl font-black">120+</p>
              <p className="mt-1 text-sm font-medium text-slate-400">
                Expert Mentors
              </p>
            </div>

            <div className="rounded-3xl border border-white/10 bg-white/[0.04] p-5">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-400/15 text-emerald-300">
                <Users size={24} />
              </div>
              <p className="text-3xl font-black">8.7k+</p>
              <p className="mt-1 text-sm font-medium text-slate-400">
                Doubts Solved
              </p>
            </div>

            <div className="rounded-3xl border border-white/10 bg-white/[0.04] p-5">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-400/15 text-orange-300">
                <ShieldCheck size={24} />
              </div>
              <p className="text-3xl font-black">10+</p>
              <p className="mt-1 text-sm font-medium text-slate-400">
                Years Experience
              </p>
            </div>
          </div>

          <div className="grid gap-10 lg:grid-cols-12">
            <div className="lg:col-span-4">
              <a href="/" title="Mediit Academy Home" className="inline-flex items-center">
                <img
                  src={logo}
                  alt="Mediit Academy - Online Learning Platform for JEE NEET and Foundation Courses"
                  className="h-auto w-56 object-contain"
                />
              </a>

              <p className="mt-6 max-w-md text-sm leading-7 text-slate-400">
                 Mediit Academy is a smart online learning platform designed for Class 7 to
                Class 12 students, JEE aspirants, and NEET aspirants. We provide live classes,
                structured courses, online test series, study material, doubt-solving support,
                and an active learning community to help students prepare with confidence.
              </p>

              <div className="mt-6 space-y-4">
                <div className="flex gap-3 text-sm text-slate-300">
                  <MapPin className="mt-1 shrink-0 text-cyan-300" size={18} />
                  <span>
                    India based online learning platform for school students,
                    JEE preparation, NEET preparation and foundation courses.
                  </span>
                </div>

                <a
                  href={`tel:${contact.phone}`}
                  title="Call Mediit Academy Support"
                  className="flex gap-3 text-sm text-slate-300 transition hover:text-cyan-300"
                >
                  <Phone className="mt-1 shrink-0 text-cyan-300" size={18} />
                  <span>{contact.displayPhone}</span>
                </a>

                <a
                  href={`mailto:${contact.email}`}
                  title="Email Mediit Academy Support"
                  className="flex gap-3 text-sm text-slate-300 transition hover:text-cyan-300"
                >
                  <Mail className="mt-1 shrink-0 text-cyan-300" size={18} />
                  <span>{contact.email}</span>
                </a>
              </div>

              <div className="mt-7 flex flex-wrap gap-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    title={social.title}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex h-11 w-11 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.05] text-slate-300 transition hover:-translate-y-0.5 hover:bg-cyan-400 hover:text-slate-950"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            <div className="grid gap-8 sm:grid-cols-3 lg:col-span-5">
              <div>
                <h4 className="text-base font-black text-white">Courses</h4>
                <ul className="mt-5 space-y-3">
                  {courses.map((item) => (
                    <li key={item.label}>
                      <a
                        href={item.href}
                        title={item.title}
                        className="group inline-flex items-center gap-2 text-sm font-medium text-slate-400 transition hover:text-cyan-300"
                      >
                        <span className="h-1.5 w-1.5 rounded-full bg-slate-600 transition group-hover:bg-cyan-300" />
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="text-base font-black text-white">Quick Links</h4>
                <ul className="mt-5 space-y-3">
                  {quickLinks.map((item) => (
                    <li key={item.label}>
                      <a
                        href={item.href}
                        title={item.title}
                        className="group inline-flex items-center gap-2 text-sm font-medium text-slate-400 transition hover:text-cyan-300"
                      >
                        <span className="h-1.5 w-1.5 rounded-full bg-slate-600 transition group-hover:bg-cyan-300" />
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="text-base font-black text-white">Support</h4>
                <ul className="mt-5 space-y-3">
                  {supportLinks.map((item) => (
                    <li key={item.label}>
                      <a
                        href={item.href}
                        title={item.title}
                        className="group inline-flex items-center gap-2 text-sm font-medium text-slate-400 transition hover:text-cyan-300"
                      >
                        <span className="h-1.5 w-1.5 rounded-full bg-slate-600 transition group-hover:bg-cyan-300" />
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="lg:col-span-3">
              <div className="rounded-[2rem] border border-white/10 bg-white/[0.05] p-6 shadow-xl backdrop-blur">
                <h4 className="text-xl font-black text-white">Get Updates</h4>
                <p className="mt-3 text-sm leading-6 text-slate-400">
                 Subscribe to get the latest live batch updates, JEE and NEET course announcements, online test series, study notes, and exclusive student offers.
                </p>

                <form className="mt-5 space-y-3">
                  <input
                    id="footerEmail"
                    name="footerEmail"
                    type="email"
                    placeholder="Enter your email"
                    autoComplete="email"
                    className="w-full rounded-2xl border border-white/10 bg-white/10 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-cyan-300"
                  />

                  <button
                    type="submit"
                    className="flex w-full items-center justify-center gap-2 rounded-2xl bg-cyan-400 px-4 py-3 text-sm font-black text-slate-950 transition hover:bg-cyan-300"
                  >
                    Subscribe Now
                    <ArrowRight size={17} />
                  </button>
                </form>
              </div>

              <div className="mt-6 rounded-[2rem] border border-white/10 bg-gradient-to-br from-blue-600/20 to-cyan-400/10 p-6">
                <div className="flex items-center gap-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 text-cyan-300">
                    <Smartphone size={24} />
                  </div>
                  <div>
                    <h4 className="font-black text-white">Download App</h4>
                    <p className="text-xs font-medium text-slate-400">
                      Learn anytime, anywhere
                    </p>
                  </div>
                </div>

                <a
                  href="/download-app"
                  title="Download Mediit Academy Learning App"
                  className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-white/10 bg-white/[0.06] px-4 py-3 text-sm font-black text-white transition hover:bg-white/[0.1]"
                >
                  Coming Soon
                  <ArrowRight size={16} />
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 border-t border-white/10 pt-8">
            <h4 className="text-sm font-black uppercase tracking-[0.2em] text-slate-400">
              Popular Learning Categories
            </h4>

            <div className="mt-5 flex flex-wrap gap-3">
              {popularCategories.map((tag) => (
                <a
                  key={tag.label}
                  href={tag.href}
                  title={tag.title}
                  className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-xs font-bold text-slate-300 transition hover:border-cyan-300/50 hover:bg-cyan-300/10 hover:text-cyan-200"
                >
                  {tag.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="relative border-t border-white/10 px-4 py-6 sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 text-center lg:flex-row lg:items-center lg:justify-between lg:text-left">
          <div>
            <p className="text-sm font-semibold text-slate-400">
              © 2026{" "}
              
                Mediit Academy
             
              . All rights reserved.
            </p>

            <p className="mt-1 text-xs font-medium text-slate-500">
              Managed by{" "}
              <a
                href={brandLinks.managedBy}
                title="NADEZHDA VENTURE PRIVATE LIMITED"
                target="_blank"
                rel="noopener noreferrer"
                className="font-black text-slate-300 transition hover:text-cyan-300"
              >
                NADEZHDA VENTURE PRIVATE LIMITED
              </a>
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-slate-400">
            <a href="/privacy-policy" title="Privacy Policy" className="transition hover:text-cyan-300">
              Privacy
            </a>
            <a href="/terms-and-conditions" title="Terms and Conditions" className="transition hover:text-cyan-300">
              Terms
            </a>
            <a href="/refund-policy" title="Refund Policy" className="transition hover:text-cyan-300">
              Refund
            </a>
            <a href="/sitemap.xml" title="Website Sitemap" className="transition hover:text-cyan-300">
              Sitemap
            </a>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;